<!-- sandbox deliberately omits allow-scripts: see the component header before
     changing it. allow-same-origin alone lets us write and measure the document
     without letting anything in the message run. -->
<iframe #frame class="email-frame" title="Email message" [style.height.px]="height"
  sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
